// extracted by mini-css-extract-plugin
export default {"section":"contact_section__BLDE5","map__container":"contact_map__container__2+o3T"};